import { toggleIn } from "./hikvisionControl";
import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

// Picks the cameras (channels) the selected rules apply to - channelChoices is already narrowed
// to the rules' groups (thermal channels for thermal rules, regular channels otherwise).
const HikvisionStepCameras = ({ channelChoices, selectedChannels, setSelectedChannels, onNext, onBack, isLastStep, lastStepLabel = "Link Hikvision" }) => (
    <>
        <StepHeader title="Which cameras would you like to control?" subtitle="The selected rules will apply to these cameras" />
        <StepBody>
            {channelChoices.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No cameras were found for the selected rules.
                </p>
            )}
            {channelChoices.map(channel => (
                <OptionCard
                    key={channel.id}
                    title={channel.name}
                    subtitle={`Channel ${channel.id}`}
                    selected={selectedChannels.includes(channel.id)}
                    onClick={() => setSelectedChannels(prev => toggleIn(prev, channel.id))}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={selectedChannels.length === 0}
            nextLabel={isLastStep ? lastStepLabel : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepCameras;
